import { render, staticRenderFns } from "./dsgvo.vue?vue&type=template&id=16f68e4e&"
import script from "./dsgvo.vue?vue&type=script&lang=ts&"
export * from "./dsgvo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f68e4e')) {
      api.createRecord('16f68e4e', component.options)
    } else {
      api.reload('16f68e4e', component.options)
    }
    module.hot.accept("./dsgvo.vue?vue&type=template&id=16f68e4e&", function () {
      api.rerender('16f68e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/views/dsgvo.vue"
export default component.exports